import React from "react";
import "./Projects.css";
import { FaReact, FaHardHat } from "react-icons/fa";
import myglamm from "../../assets/myglamm.png"
import shop from "../../assets/shop.com.png"
import expedia2 from "../../assets/expedia2.png"
import {
  SiBlockchaindotcom,
  SiHtml5,
  SiMaterialui,
  SiChai,
  SiEthereum,
  SiExpress,
  SiSocketdotio,
  SiTailwindcss,
  SiReactrouter,
  SiJavascript,
  SiMongodb,
  SiNodedotjs,
} from "react-icons/si";
import { DiCss3 } from "react-icons/di";
import { VscJson } from "react-icons/vsc";
import { IoLogoJavascript } from "react-icons/io";
export const Projects = () => {
  return (
    <>
      <div className="section">
        <h2 className="section__title different">Projects</h2>
        <div className="allProjects">
        <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img style={{height:"15vw"}}
                    src={myglamm}
                    alt="myglamm"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>Clone of myglamm.com</h2>
                <p>
                MyGlamm is an Indian e-commerce company that sells cosmetics and personal care products.
                It was founded in 2015 in Mumbai, India.
                {/* on the website, travellers can book everything they need for
                a holiday - rooms to meet every budget, activities of every
                kind and travel services to complement. */}
                </p>
                <div>
                  <SiNodedotjs />
                  <SiExpress />
                  <SiMongodb />
                  <FaReact />
                  <SiMaterialui />
                </div>
                <div>
                  <a
                    href="https://myglammprojectunit5.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/mobin07/myglamm"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>





          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img style={{height:"15vw"}}
                    src={expedia2}
                    alt="Expedia"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>Expedia</h2>
                <p>
                Expedia is one of the fastest growing online travel portals
                in Asia, offering travellers an extensive selection of hotels,
                activities and travel services.
                 {/* to meet every budget and 
                activities of every kind at competitive rates. With over 
                hundreds of thousands of hotel partners worldwide and a 
                comprehensive offering of flight inventory made available 
                on the website. */}
                {/* on the website, travellers can book everything they need for
                a holiday - rooms to meet every budget, activities of every
                kind and travel services to complement. */}
                </p>
                <div>
                  <SiNodedotjs />
                  <SiExpress />
                  <SiMongodb />
                  <FaReact />
                  <SiMaterialui />
                </div>
                <div>
                  <a
                    href="https://expedia-clone-004.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/arunrajbhar123/expedia"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img style={{height:"15vw"}}
                    src={shop}
                    alt="Shop.com"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>Shop.com</h2>
                <p>
                SHOP.COM is a new kind of shopping comparison site that offers the
                 most comprehensive shopping experience on the web.
                  {/* Our shopping
                  experts have drawn on their industry experience and insider
                   connections to bring you the best collection of the stores 
                   you can't live without, and the brands and products you love
                    - all in one place. */}
                </p>
                <div>
                  <DiCss3 />
                  <SiHtml5 />
                  <IoLogoJavascript />
                </div>
                <div>
                  <a
                    href="https://shop-com-clone-web17.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                   >
                    <span type="button" className="btns onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/mistrivishal/SHOP.COM-clone"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
 
        </div>
      </div>
      
    </>
  );
};
